import React from 'react';
import { CheckIcon, GiftIcon, SparklesIcon } from 'lucide-react';
import { bonos } from '../data/content';
import { CTAButton } from './CTAButton';
export function Bonos() {
  return <section className="w-full bg-navy-900 px-4 py-12 sm:px-6 sm:py-16" data-id="element-57" data-mp="2leeyaku97d3e">
      <div className="mx-auto max-w-3xl" data-id="element-58" data-mp="2lc29bnq2w2gu">
        <p className="text-center text-[12px] font-extrabold uppercase tracking-[0.18em] text-teal" data-id="element-59" data-mp="2q551psj4d5vg">
          🎁 Bonos exclusivos
        </p>
        <h2 className="mt-3 text-center font-serif text-[28px] font-bold leading-tight text-white sm:text-4xl" data-id="element-60" data-mp="2v3q6845embpp">
          Además, recibirás estos{' '}
          <span className="italic text-teal" data-id="element-61" data-mp="351macbzxc6eb">5 Bonos</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-navy-100" data-id="element-62" data-mp="393r3zaqdh30y">
          Diseñados para eliminar las dudas que más frenan a un médico al
          prescribir GLP-1.
        </p>
        <p className="mx-auto mt-5 max-w-xs rounded-xl bg-white/10 px-4 py-3 text-center text-[13.5px] font-bold uppercase tracking-wide text-white" data-id="element-63" data-mp="1epgcsvmb1ws0">
          Valor total: USD $275
          <span className="mt-1 block text-[12px] font-semibold normal-case tracking-normal text-teal" data-id="element-64" data-mp="39dau2ur1b1y6">
            Hoy incluidos sin costo adicional
          </span>
        </p>

        <div className="mt-8 space-y-4" data-id="element-65" data-mp="34c3lwukzc0qz">
          {bonos.map(bono => <article key={bono.badge} className="overflow-hidden rounded-2xl bg-white shadow-lift" data-id="element-66" data-mp="2zgfzuo1snnpp">
              {bono.image && <div className="bg-cream px-4 pt-4" data-id="element-67" data-mp="3s3iu33zftca5">
                  <img src={bono.image} alt={`Vista previa del ${bono.badge}: ${bono.title}`} className="mx-auto w-full max-w-sm" loading="lazy" data-id="element-68" data-mp="3s1pnfootqs25" />
                </div>}
              <div className="p-5" data-id="element-69" data-mp="2bqtz3w5rx0fl">
                <p className="inline-flex items-center gap-1.5 rounded-full bg-teal px-3 py-1 text-[11px] font-extrabold uppercase tracking-widest text-white" data-id="element-70" data-mp="26qfs8hfwrwj5">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-71" data-mp="yrs35hz7gg0y" />
                  {bono.badge}
                </p>
                <h3 className="mt-3 font-serif text-[20px] font-bold leading-snug text-navy-900 sm:text-2xl" data-id="element-72" data-mp="12q9b23qg9ujf">
                  {bono.title}
                </h3>
                <p className="mt-2 text-[14.5px] leading-relaxed text-navy-900/80" data-id="element-73" data-mp="tqmcdpp3v2u2">
                  {bono.intro}
                </p>

                <p className="mt-4 text-[12.5px] font-extrabold uppercase tracking-wide text-navy-700" data-id="element-74" data-mp="f16iw1y6wjao">
                  {bono.listTitle}
                </p>
                <ul className="mt-2 space-y-2" data-id="element-75" data-mp="63mg2okoiexy">
                  {bono.items.map(item => <li key={item} className="flex gap-2" data-id="element-76" data-mp="b27j0vrbfcq3">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-77" data-mp="3s9t81fr41n93" />
                      <span className="text-[14px] leading-snug text-navy-900/85" data-id="element-78" data-mp="15ck4br4raba">
                        {item}
                      </span>
                    </li>)}
                </ul>

                <p className="mt-4 flex gap-2 rounded-xl bg-cream p-3 text-[13.5px] leading-snug text-navy-900" data-id="element-79" data-mp="39nlpyosifb31">
                  <SparklesIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-80" data-mp="3ilxf0mdqa0td" />
                  <span data-id="element-81" data-mp="erbpucggpd5">
                    <span className="font-bold text-brand" data-id="element-82" data-mp="dy64wp8g5wl">Resultado: </span>
                    {bono.result}
                  </span>
                </p>

                <p className="mt-4 flex flex-wrap items-center gap-2 text-[13px] font-bold text-navy-900" data-id="element-83" data-mp="a4srlyunn1gz">
                  <span className="text-navy-700/60 line-through" data-id="element-84" data-mp="57kjkr380dtg">
                    Valor: {bono.value}
                  </span>
                  <span className="rounded-md bg-teal-light px-2 py-1 text-teal" data-id="element-85" data-mp="k1xfq482970f">
                    Hoy es tuyo GRATIS
                  </span>
                </p>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-86" data-mp="2dmik6bq9xg6u">
          <CTAButton label="Quiero los 5 bonos incluidos" note="USD $275 en bonos incluidos sin costo" noteClassName="text-navy-100" data-id="element-87" data-mp="2dl7koo3v2ulj" />
        </div>
      </div>
    </section>;
}